import React from "react";

export const Divider: React.FC = () => {
  return (
    <hr
      className="w-20 rounded-full"
      style={{ borderColor: "#70707044", borderWidth: 0.5, color: "#70707044" }}
    />
  );
};
